import React, { useState, useEffect } from 'react'
import Loader from '../../component/loader/Loader'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { IoRefreshOutline } from 'react-icons/io5'
import Flatpickr from 'react-flatpickr'
import "flatpickr/dist/themes/light.css"
import { LuFileEdit, LuTrash2 } from 'react-icons/lu';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'
import DataTablePagination from '../../component/data_table/DataTablePagination';
import { useFormik } from 'formik';
import SaveButton from '../../component/buttons/SaveButton';
import { LedgerListRes, LedgerListTodo } from '../../redux/Slices/Ledger/LedgerList';
import { toast, ToastContainer } from 'react-toastify';
// import DeleteLedger from './DeleteLedger';


export default function LedgerList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const [filterLoad, setFilterLoad] = useState(false)



    const initialValues = {
        search: '',
        fromDate: '',
        toDate: ''
    }


    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,

        onSubmit: (values, action) => {
            setFilterLoad(true)
            dispatch(LedgerListTodo({ "fromDate": values.fromDate, "toDate": values.toDate })).then(() => filter_res())
        }
    })

    const handleReset = () => {
        
        // setFieldValue('fromDate', ""); // Reset fromDate
        // setFieldValue('toDate', "");   // Reset toDate
        // values.date = ''   // Reset date
        // Reset search
        setBool(!bool);                // Toggle bool state if necessary
    };


    const filter_res = () => {
        if (LedgerListRes && LedgerListRes.status) {
            setFilterLoad(false)
            toast.success(LedgerListRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                window.open(LedgerListRes?.return_file, '_blank');
            }, 1500);
           
           
        } else {
            setFilterLoad(false)
            toast.error(LedgerListRes?.message, { position: "bottom-right" });
        }
    }

    useEffect(() => {
        setLoading(true)
        // dispatch(LedgerListTodo({ "fromDate": values.fromDate, "toDate": values.toDate, })).then(() => filter_res())
    }, [bool])

    setTimeout(() => {
        setLoading(false)

    }, 500);

    // useEffect(() => {
    //     setLoading(true)
    //     dispatch(LedgerListTodo({ "fromDate": values.fromDate, "toDate": values.toDate, })).then(() => ledgerListFun())
    // }, [bool])

    // const ledgerListFun = () => {
    //     if (LedgerListRes && LedgerListRes.success) {
    //         setLoading(false)
    //     } else {
    //         setLoading(false)
    //     }
    // }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">

                        <div className='layout_head'>
                            <h5>Ledger List</h5>
                        </div>
                        {filterLoad || loading ?
                            <div className='mt-5 pt-5'>
                                <Loader />
                            </div>
                            :
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                               
                                <div className="col-md-3">
                                    <label htmlFor="" className='form_label'>From Date</label>
                              
                                        <Flatpickr
                                            className='form_input form-control'
                                            name='fromDate'
                                            // value={values?.fromDate || new Date().toISOString()}
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: 'm-d-Y', // Customize date format as needed
                                                minDate: '', // Before dates disabled
                                                maxDate: '', // After dates disabled
                                                disable: [], // Disable particular date ranges
                                                mode: "single", //multiple-single-range
                                                defaultDate: [], // Use today's date as default if none selected
                                                conjunction: "", // Multiple dates separation
                                            }}
                                            onChange={(e) => {
                                                setFieldValue('fromDate', moment(e[0]).format("DD/MM/YYYY"))
                                            }}
                                            onBlur={handleBlur}
                                        />

                                </div>
                                <div className="col-md-3">
                                    <label htmlFor="" className='form_label'>To Date</label>
                              
                                        <Flatpickr
                                            className='form_input form-control'
                                            name='toDate'
                                            // value={values?.toDate || new Date().toISOString()}
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: 'm-d-Y', // Customize date format as needed
                                                minDate: '', // Before dates disabled
                                                maxDate: '', // After dates disabled
                                                disable: [], // Disable particular date ranges
                                                mode: "single", //multiple-single-range
                                                defaultDate: [], // Use today's date as default if none selected
                                                conjunction: "", // Multiple dates separation
                                            }}
                                            onChange={(e) => {
                                                setFieldValue('toDate', moment(e[0]).format("DD/MM/YYYY"))
                                            }}
                                            onBlur={handleBlur}
                                        />

                                </div>
                                <div className="col-md-3">
                                    <div className='d-flex align-items-center mt-4 mb-1'>
                                        <SaveButton name={'PDF Generate'} />
                                        <button className='ms-1 refresh_btn' type='button' onClick={handleReset} ><IoRefreshOutline style={{ color: 'white' }} size={25} /></button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    
                          
                        }
                    </div>
                </div>
            </div>
            <ToastContainer/>
            {/* <DeleteLedger deleteModal={deleteModal} setDeleteModal={setDeleteModal} ledgerData={ledgerData} bool={bool} setBool={setBool} /> */}
        </>
    )
}
